import { UserRole } from 'app/core/auth/auth.repository';

export type ManualRole = 'courseadmin' | 'supervisor' | 'student' | 'translator';

/** The manual roles a user may read, most specific first. Everyone else sees no manuals. */
export function manualRolesFor(role: UserRole | undefined): ManualRole[] {
  switch (role) {
    case UserRole.SuperUser:
    case UserRole.SysAdmin:
    case UserRole.CourseAdmin:
      return ['courseadmin', 'supervisor', 'student', 'translator'];
    case UserRole.Supervisor:
    case UserRole.Advisor:
      return ['supervisor', 'student'];
    case UserRole.Translator:
      return ['translator'];
    case UserRole.Student:
      return ['student'];
    default:
      return [];
  }
}

/** Tailwind classes per role: icon tile background, icon color, ring of the active filter card. */
export const MANUAL_ROLE_STYLE: Record<ManualRole, { tile: string; icon: string; ring: string }> = {
  courseadmin: { tile: 'bg-indigo-50 dark:bg-indigo-900/30', icon: 'text-indigo-600 dark:text-indigo-400', ring: 'ring-indigo-500' },
  supervisor: { tile: 'bg-teal-50 dark:bg-teal-900/30', icon: 'text-teal-600 dark:text-teal-400', ring: 'ring-teal-500' },
  student: { tile: 'bg-amber-50 dark:bg-amber-900/30', icon: 'text-amber-600 dark:text-amber-400', ring: 'ring-amber-500' },
  translator: { tile: 'bg-violet-50 dark:bg-violet-900/30', icon: 'text-violet-600 dark:text-violet-400', ring: 'ring-violet-500' },
};
